import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
//import Dashboard from './../components/Menu/Dashboard'
import PropTypes from 'prop-types';
//import LoadingScreen from '../components/Complements/LoadingScreen';
import { Grid } from '@material-ui/core';
//import { isMobile } from 'react-device-detect';
import Button from '@material-ui/core/Button';

//import Title from './../components/Complements/Title';
//import Footer from '../components/Complements/Footer';
import { history } from '../helpers/history';

class TransferOptionsContainer extends Component {


  handleOnClick = () => {
    this.props.history.push('/customers')
  }

  renderAllBody = (renderBody) => {
    return <Grid container alignItems='center' style={{gap:10}}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          fullWidth
          variant="contained"
          onClick={() => history.push('/own-transfers')}
          style={{
              fontSize: '12px',
              color: '#ffffff',
              borderRadius: '4px',
              '&.Mui-disabled': {
                  backgroundColor: "#a7a8a8",
              },
              '&:hover': {
                  backgroundColor: "#706D85",
              },
              backgroundColor: "#2E2757",
              //fontFamily: 'MyriadPro-Bold'
          }}
        >Transferencia a cuentas propias</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          fullWidth
          variant="contained"
          onClick={() => history.push('/internal-transfers')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
                backgroundColor: "#a7a8a8",
            },
            '&:hover': {
                backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
        }}
        >Transferencia a otros socios</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          fullWidth
          variant="contained"
          onClick={() => history.push('/external-transfers')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
                backgroundColor: "#a7a8a8",
            },
            '&:hover': {
                backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
        }}
        >Transferencia a otras instituciones</Button>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent='center'>
        <Button
          fullWidth
          variant="contained"
          onClick={() => history.push('/credit-card-payment')}
          style={{
            fontSize: '12px',
            color: '#ffffff',
            borderRadius: '4px',
            '&.Mui-disabled': {
                backgroundColor: "#a7a8a8",
            },
            '&:hover': {
                backgroundColor: "#706D85",
            },
            backgroundColor: "#2E2757",
            //fontFamily: 'MyriadPro-Bold'
        }}
        >Pago de tarjetas</Button>
      </Grid>
    </Grid>
  }

  render() {
    const { renderBody/* , loading */ } = this.props
    return (
      <div
      style={{
        padding: "20px 10px",
      }}
      >
        {/*<Dashboard
          title="Dashboard"
          body={this.renderAllBody(renderBody)}
          multiple={false}
        />
         <LoadingScreen open={!loading} />
         <Footer /> */}
         {this.renderAllBody(renderBody)}
      </div>
    );
  }
}

TransferOptionsContainer.propTypes = {
  user: PropTypes.object,
}

export default withRouter(TransferOptionsContainer);